import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const BulkBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(0.5, 2)
}));

export const TonalButton = styled(Button)(({ theme, color }) => ({
  '&&': {
    padding: theme.spacing(0.5, 1.5),
    minHeight: 30,
    fontSize: 13,
    ...((color === 'success' || color === 'error') && {
      background: theme.palette[color].container,
      color: theme.palette[color].onContainer,
      border: `1px solid ${theme.palette[color].container}`,
      '&:hover': {
        background: theme.palette[color].container,
        filter: 'brightness(0.95)'
      }
    })
  }
}));
